import { render, staticRenderFns } from "./Show.vue?vue&type=template&id=31b0a753&scoped=true&"
import script from "./Show.vue?vue&type=script&lang=js&"
export * from "./Show.vue?vue&type=script&lang=js&"
import style0 from "./Show.vue?vue&type=style&index=0&id=31b0a753&prod&lang=css&"
import style1 from "./Show.vue?vue&type=style&index=1&id=31b0a753&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b0a753",
  null
  
)

export default component.exports